import React from 'react';
import { useNavigate } from 'react-router-dom';
import { designSystem } from '@yola/ws-ui';
import i18next from 'i18next';
import routesMap from 'src/js/router/helpers/routes-map';
import { premiumFeatures } from 'src/js/modules/common/constants/premium-features';
import segment from '../../analytics/segment';

const { CtaBanner } = designSystem;
const {
  constants: { triggerIds, events },
  track,
} = segment;

const getCaptions = () => ({
  title: i18next.t('Upgrade Online store'),
  subtitle: i18next.t('Unlock your store’s true potential'),
  label: i18next.t('Upgrade now!'),
});

const OnlineStoreBannerContainer = () => {
  const navigate = useNavigate();
  const captions = getCaptions();

  const redirectToOnlineStore = () => {
    track(events.ONLINE_STORE_TRIGGER_CLICKED, {
      triggerId: triggerIds.BANNER,
      siteId: null,
    });
    navigate(
      routesMap.ecommercePaywall.url({
        query: {
          triggerId: triggerIds.BANNER,
          actionId: triggerIds.MYYOLA_ONLINE_STORE_BANNER,
          paymentBackUrl: window.location.href,
          premiumFeature: premiumFeatures.ECOMMERCE,
        },
      })
    );
  };

  return (
    <CtaBanner
      title={captions.title}
      subtitle={captions.subtitle}
      ctaButton={{
        label: captions.label,
        onClick: redirectToOnlineStore,
      }}
      iconGlyph="online-store"
      layout="mobile"
      animate={false}
    />
  );
};

export default OnlineStoreBannerContainer;
